<template>
  <div>
    <!--
    <div class="row">
      <div class="col-12 col-md-6">
      
      </div>
      
    </div>-->
    <div class="container" id="main">
      <div class="row justify-content-center">
        <div
          id="content"
          class="col-12 col-lg-8 text-danger"
        ><h1>{{LanguageStrings[DisplayLanguage][$parent.globalError]}}</h1></div>
      </div>
    </div>
    <BottomNav />
  </div>
</template>

<script>
import BottomNav from "../components/BottomNav";

export default {
  name: "GlobalError",
  components: {
    BottomNav
  },
  data: function() {
    return {};
  },
  mounted: function() {},
  computed: {},
  methods: {}
};
</script>

<style scoped>
@media screen {
  /*table {
    border-collapse: collapse;
    border-spacing: 0;
  }*/

  #main {
    margin-top: 40px;
  }

  #globalerror {
    padding: 0px;
    margin-bottom: 0px;
  }

  #footer {
    padding: 0px;
    margin-top: 10px;
  }

  #content {
    margin-bottom: 10px;
    padding: 20px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    text-align:center;
  }

  h1 {
    font-size: 20px;
    margin-bottom: 0px;
  }

  h2 {
    font-size: 15px;
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  /*
  ul {
    margin-left: 20px;
  }
  p {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  td {
    padding-bottom: 7px;
  }
  li {
    margin-bottom: 7px;
  }
  li a {
    text-decoration: none;
    font-weight: bold;
  }

  .tablekey {
    font-weight: bold;
  }

  hr {
    display: block;
    height: 1px;
    border: 0;
    margin: 1em 0;
    padding: 0;
    margin-top: 20px;
  }
  .tablevalue {
    padding-left: 10px;
  }*/
}
</style>
